var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeMenu,
          expression: "closeMenu",
        },
      ],
      staticClass: "sip-side-profile",
      class: { "is-open": _vm.menuOpen },
    },
    [
      _c(
        "button",
        {
          ref: "profileBtn",
          staticClass: "sip-side-profile__btn",
          attrs: {
            type: "button",
            "aria-expanded": _vm.menuOpen ? "true" : "false",
            "aria-label": _vm.displayName,
            title: _vm.isCollapsed ? _vm.displayName : null,
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggleMenu.apply(null, arguments)
            },
          },
        },
        [
          _c("span", { staticClass: "sip-avatar-wrap" }, [
            _c(
              "span",
              { staticClass: "sip-avatar", attrs: { "aria-hidden": "true" } },
              [_vm._v(_vm._s(_vm.initials))]
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "sip-avatar-status",
              attrs: { title: "Online", "aria-hidden": "true" },
            }),
          ]),
          _vm._v(" "),
          !_vm.isCollapsed
            ? _c("span", { staticClass: "sip-side-profile__meta" }, [
                _c("span", { staticClass: "sip-side-profile__name" }, [
                  _vm._v(_vm._s(_vm.displayName)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "sip-side-profile__role-badge" }, [
                  _vm._v(_vm._s(_vm.userRole)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isCollapsed
            ? _c(
                "span",
                {
                  staticClass: "sip-side-profile__action",
                  attrs: { title: "Account Menu" },
                },
                [
                  _c("admin-icon", {
                    staticClass: "sip-side-profile__chev",
                    attrs: { name: "chevron-down", size: 13 },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "profileMenu",
          staticClass: "sip-side-profile__menu",
          style: _vm.menuPos,
          attrs: { role: "menu" },
        },
        [
          _vm.email
            ? _c("div", { staticClass: "sip-side-profile__email" }, [
                _vm._v(_vm._s(_vm.email)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRole("admin")
            ? _c(
                "a",
                { attrs: { href: "/subscription", role: "menuitem" } },
                [
                  _c("admin-icon", { attrs: { name: "card", size: 16 } }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.trans("subscription.subscription"))),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            { attrs: { href: "/change/password", role: "menuitem" } },
            [
              _c("admin-icon", { attrs: { name: "lock", size: 16 } }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.trans("user.change_password")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "text-danger",
              attrs: { href: "#", role: "menuitem" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.logout.apply(null, arguments)
                },
              },
            },
            [
              _c("admin-icon", { attrs: { name: "logout", size: 16 } }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.trans("auth.logout")))]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }